import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { translations } from './configs/primeapi.config';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { SessionEventService } from './modules/login/session-event.service';
import { RouterConstant } from './constants/router.constant';
import { SessionReasonConstant } from './constants/session.constant';

/**
 * Componente de inicio de la aplicacion Admin
 */
@Component({
  selector: 'app-root',
  template: '<app-spinner></app-spinner> <router-outlet></router-outlet>'
})
export class AppComponent implements OnInit, OnDestroy {
  devToolsOpen = false;
  previousInnerHeight = window.innerHeight;
  previousInnerWidth = window.innerWidth;
  private sub!: Subscription;
  private redirigiendoPorSesionExpirada = false;

  constructor(private primeNG: PrimeNGConfig, private router: Router,
    private sessionEventService: SessionEventService) {
    this.detectDevTools();
    this.primeNG.setTranslation(translations);
  }

  ngOnInit() {
    this.sub = this.sessionEventService.onSessionInvalid.subscribe(() => {
      const isAlreadyLogin = this.router.url.includes(RouterConstant.NAVIGATE_LOGIN);
      if (isAlreadyLogin || this.redirigiendoPorSesionExpirada) return;

      this.redirigiendoPorSesionExpirada = true;
      this.router.navigateByUrl(`${RouterConstant.NAVIGATE_LOGIN}?reason=${SessionReasonConstant.INVALID}`, { replaceUrl: true })
        .then(() => { this.redirigiendoPorSesionExpirada = false; });
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  @HostListener('document:keydown', ['$event'])
  handlerKeyboardEvent(event: KeyboardEvent) {
    if (
      event.key === 'F12' ||
      (event.ctrlKey && event.shiftKey && event.key === 'I' && environment.production) ||
      (event.ctrlKey && event.shiftKey && event.key === 'J' && environment.production)
    ) {
      event.preventDefault();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (environment.production) {
      const innerWidth = window.innerWidth;
      const innerHeight = window.innerHeight;

      if (
        this.previousInnerHeight !== innerHeight ||
        this.previousInnerWidth !== innerWidth
      ) {
        this.devToolsOpen = true;
        this.detectDevTools();
      }

      this.previousInnerHeight = innerHeight;
      this.previousInnerWidth = innerWidth;
    }
  }

  detectDevTools() {
    if (environment.production) {
      const threshold = 160;
      if (window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold) {
        window.location.href = 'about:blank'
      }

      setInterval(() => {
        if (window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold) {
          window.location.href = 'about:blank'
        }
      }, 1000)
    }
  }
}
